import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "container"
}
const _hoisted_2 = {
  key: 1,
  id: "footer",
  class: "text-center p-3"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["href"]

import { useAppCustomizations } from '@/composables/useAppCustomizations';
import AppCustomizationsModel from '@/models/AppCustomizationsModel';

import { onMounted, ref, watchEffect } from 'vue';
import { useCookiebot } from './composables/useCookiebot';
import useCookieStandardPolicy from './composables/useCookieStandardPolicy';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { getAppCustomizations } = useAppCustomizations();
const { cookiebotId, isEnabled: isCookiebotEnabled } = useCookiebot();
const { standardPolicyUrl } = useCookieStandardPolicy();

const appCustomizations = ref<AppCustomizationsModel | null>(null);       
const fetchCompleted = ref<boolean>(false);
const showCookiebotPolicy = ref<boolean>(false);
const cookieDeclarationContainer = ref<any>(null);

const onShowCookiebotPolicy = () => {
  showCookiebotPolicy.value = true;
};

const onHideCookiebotPolicy = () => {
  showCookiebotPolicy.value = false;
};

watchEffect(() => {
  if (cookieDeclarationContainer.value) {
    // crea tag script per dichiarazione cookie
    let cookiePolicyScript = document.createElement("script")
    cookiePolicyScript.setAttribute("id", "CookieDeclaration");
    cookiePolicyScript.setAttribute("src", `https://consent.cookiebot.com/${cookiebotId}/cd.js`);
    cookiePolicyScript.setAttribute("async", "");
    cookiePolicyScript.setAttribute("defer", "");
    
    cookieDeclarationContainer.value.appendChild(cookiePolicyScript);
  }
})

onMounted(async () => {
  fetchCompleted.value = false;
  if (isCookiebotEnabled.value) {
    // aggiunge script cookiebot  
    let externalScript = document.createElement('script')
    externalScript.setAttribute("id", "Cookiebot");
    externalScript.setAttribute('src', 'https://consent.cookiebot.com/uc.js')
    externalScript.setAttribute('data-cbid', cookiebotId);
    externalScript.setAttribute('data-blockingmode', "auto");
    document.head.insertBefore(externalScript, document.head.firstChild);
  }
  
  appCustomizations.value = await getAppCustomizations();

  fetchCompleted.value = true;
});


return (_ctx: any,_cache: any) => {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (fetchCompleted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Header, {
            bgColor: appCustomizations.value?.backgroundColorRgb,
            logoUrl: appCustomizations.value?.appLogoUrl
          }, null, 8, ["bgColor", "logoUrl"]),
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    (fetchCompleted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(isCookiebotEnabled))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                onClick: _withModifiers(onShowCookiebotPolicy, ["stop","prevent"])
              }, "Informativa cookie", 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _unref(standardPolicyUrl),
                target: "_blank"
              }, "Informativa cookie", 8, _hoisted_4))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      header: "Informativa cookie",
      visible: showCookiebotPolicy.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showCookiebotPolicy).value = $event)),
      breakpoints: {'960px': '75vw', 'showCookiebotPolicy': '90vw'},
      style: {width: '50vw'},
      modal: true,
      closable: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Ok",
          icon: "pi pi-check",
          onClick: onHideCookiebotPolicy,
          autofocus: ""
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "cookieDeclarationContainer",
          ref: cookieDeclarationContainer
        }, null, 512)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})